import { render, staticRenderFns } from "./foodPackListwrite.vue?vue&type=template&id=0582f79a&scoped=true&"
import script from "./foodPackListwrite.vue?vue&type=script&lang=js&"
export * from "./foodPackListwrite.vue?vue&type=script&lang=js&"
import style0 from "./foodPackListwrite.vue?vue&type=style&index=0&id=0582f79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582f79a",
  null
  
)

export default component.exports